export const CONTACT_TYPES = {
  USER: 'user',
  EMAIL: 'email',
  PHONE: 'phone', // Future extension
};

export const createContact = (type, value) => ({ 
  type, 
  [type === CONTACT_TYPES.USER ? 'id' : 'value']: value 
});

export const getContactValue = (contact) => contact.id || contact.value;

export const getContactDisplay = (contact, users = []) => {
  switch (contact.type) {
    case CONTACT_TYPES.USER:
      return users.find(u => u.id === contact.id)?.userEmail || 'Unknown User';
    case CONTACT_TYPES.EMAIL:
      return contact.value;
    case CONTACT_TYPES.PHONE:
      return contact.value;
    default:
      return contact.value;
  }
};

export const contactsEqual = (contact1, contact2) => {
  // Safety check for null/undefined contacts
  if (!contact1 || !contact2) {
    return false;
  }
  return contact1.type === contact2.type && getContactValue(contact1) === getContactValue(contact2);
};
